import axios from "../../axios";

type PartnerDefinition =
    | {
          foreignProvider: false;
      }
    | {
          foreignProvider: true;
          companyName: string;
          companyWeb: string;
      };
export type PartnerResponse = {
    corrected: boolean;
    address: {
        zipCode: string;
        city: string;
        street: string;
        houseNumber: string;
    };
    partners: {
        power?: PartnerDefinition;
        gas?: PartnerDefinition;
    };
    verificationSkipped: boolean;
};

export class AddressClient {
    private async complete(
        zipCode: string,
        city: string,
        limit = 10,
        field: "zipCode" | "street" | "city",
        street?: string,
    ): Promise<string[]> {
        try {
            const response = await axios.get<string[]>("address/completion", {
                headers: {
                    "Content-Type": "application/json",
                },
                params: {
                    zipCode,
                    city,
                    street,
                    limit,
                    field,
                },
            });
            if (response.status !== 200) {
                console.log("incompletable address or rate limit");
                return [];
            }
            return response.data;
        } catch (e) {
            if (!e.isAxiosError) {
                console.error(e);
            }
            return [];
        }
    }

    async completeZipCode(zipCode: string, city: string, limit = 10): Promise<string[]> {
        return await this.complete(zipCode, city, limit, "zipCode");
    }

    async completeCity(zipCode: string, city: string, limit = 10): Promise<string[]> {
        return await this.complete(zipCode, city, limit, "city");
    }
    async completeStreet(
        zipCode: string,
        city: string,
        street: string,
        limit = 10,
    ): Promise<string[]> {
        return await this.complete(zipCode, city, limit, "street", street);
    }

    async requestPartners(
        zipCode: string,
        city: string,
        street: string,
        houseNumber: string,
    ): Promise<PartnerResponse | null> {
        try {
            const response = await axios.get<PartnerResponse>("address/partner", {
                headers: {
                    "Content-Type": "application/json",
                },
                params: {
                    zipCode,
                    city,
                    street,
                    houseNumber,
                },
            });
            return response.data;
        } catch (e) {
            if (!e.isAxiosError) {
                console.error(e);
            }
            return null;
        }
    }
}

export const defaultAddressClient = new AddressClient();
